import { createReducer } from '../../store.model';

import { ActionType } from './search.action';
import { defaultState, SearchState } from './search.state';
import { LoadMore } from './state/load-more.action';
import { loadMoreReducer } from './state/load-more.reducer';
import { Reload } from './state/reload.action';
import { reloadReducer } from './state/reload.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { RunSearch, RunSearchResult } from './state/run-search.action';
import {
    runSearchReducer,
    runSearchResultReducer,
} from './state/run-search.reducer';
import { SelectUser } from './state/select-user.action';
import { selectUserReducer } from './state/select-user.reducer';
import { SortRows } from './state/sort-rows.action';
import { sortRowsReducer } from './state/sort-rows.reducer';

const { reducer, builder } = createReducer<ActionType, SearchState>(
    defaultState(),
);

builder.add<Reload>(ActionType.EVAL_SEARCH__RELOAD, reloadReducer);

builder.add<SelectUser>(ActionType.EVAL_SEARCH__SELECT_USER, selectUserReducer);

builder
    .add<RunSearch>(ActionType.EVAL_SEARCH__RUN_SEARCH, runSearchReducer)
    .add<RunSearchResult>(
        ActionType.EVAL_SEARCH__RUN_SEARCH_RESULT,
        runSearchResultReducer,
    );

builder.add<LoadMore>(ActionType.EVAL_SEARCH__LOAD_MORE, loadMoreReducer);

builder.add<SortRows>(ActionType.EVAL_SEARCH__SORT_ROWS, sortRowsReducer);

builder.add<Reset>(ActionType.EVAL_SEARCH__RESET, resetReducer);

export const searchReducer = reducer;
